<template>
  <button class="button-back" type="button" @click="$emit('click')">
    <v-icon medium>chevron_left</v-icon> Back
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.button-back {
  align-items: center;
  color: $typography-color-body;
  display: inline-flex;
  font-family: $typography-font-primary;
  font-size: 1rem;
  font-weight: $typography-weight-bold;
  letter-spacing: 0.125rem;
  text-transform: uppercase;

  .v-icon {
    color: $typography-color-body;
  }
}
</style>
